import { render, staticRenderFns } from "./SlaughterBarChartReport.vue?vue&type=template&id=cbc50a28&scoped=true&"
import script from "./SlaughterBarChartReport.vue?vue&type=script&lang=js&"
export * from "./SlaughterBarChartReport.vue?vue&type=script&lang=js&"
import style0 from "./SlaughterBarChartReport.vue?vue&type=style&index=0&id=cbc50a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc50a28",
  null
  
)

export default component.exports